<template>
  <div class="detail-settings" v-if="showInEnv(env_emeta) || showInEnv([env_tentacles, env_flower])">
    <div class="detail-settings__panel">
      <div class="detail-settings__panel__header">{{ $t('detail.sensor_setting') }}</div>
      <BatchSelection
              :batch="unit.batch"
              :properties="unit.properties"
              :allMoistureSensors="allMoistureSensors"
              :device="unit"
              @dirtyBatch="(value) => $emit('dirtyBatch', value)"
      />
      <div class="detail-settings__panel__content">
        <div class="settings-row" v-if="this.showLqi">
          <div class="settings-row__name">
            <div class="settings-row__name__title">{{ $t('detail.lqi') }}</div>
            <div class="settings-row__name__description">{{ $t('detail.lqi_calculated') }}</div>
          </div>
          <div class="settings-row__actions" style="min-width: 20rem;">
            <div :class="['lqi-info', unit.lqi]">{{ $t('lqi.' + unit.lqi) }}</div>
          </div>
        </div>
        <DetailSettingsRow
          v-for="sensor in sensors"
          :key="sensor.id"
          :sensor="sensor"
        />
      </div>
        <transition name="fade">
            <div v-if="loading" class="loading-wrapper">
                <BaseSpinner text="info.loading_data" />
            </div>
        </transition>
    </div>
  </div>

  <div class="detail-settings" v-else-if="showInEnv(env_etentacles)">
    <div class="detail-settings__panel">
      <div class="detail-settings__panel__header">{{ $t('detail.etentacles_setting') }}</div>
      <BatchSelection
              :batch="unit.batch"
              :properties="unit.properties"
              :device="unit"
              :allMoistureSensors="allMoistureSensors"
              @dirtyBatch="(value) => $emit('dirtyBatch', value)"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { dynamicTiming, dynamicSensing } from '@/config/tentacles';
import DetailSettingsRow from '@/views/detail/DetailSettingsRow.vue';
import BatchSelection from '@/views/detail/BatchSelection.vue';

export default {
  name: 'DetailSettings',
  props: {
    unit: {
      type: Object,
    },
    sensors: {
      type: Array,
    },
    allMoistureSensors: {
      type: Array,
      required: false,
    },
  },
  components: {
    BatchSelection,
    DetailSettingsRow,
  },
  data() {
    return {
      SOIL_3XS: 1,
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
      env_flower: process.env.VUE_APP_ENV_FLOWER,
    };
  },
  computed: {
    ...mapGetters('tentacle', ['type']),
    dynamicTiming() {
      for (let i = 0; i < dynamicTiming.length; i += 1) {
        dynamicTiming[i].name = this.$t(`timing.${dynamicTiming[i].label}`);
      }
      return dynamicTiming;
    },
    dynamicSensing() {
      for (let i = 0; i < dynamicSensing.length; i += 1) {
        dynamicSensing[i].name = this.$t(`sensing.${dynamicSensing[i].label}`);
      }
      return dynamicSensing;
    },
    loading() {
      return this.$store.getters['tentacle/loading'];
    },
    showLqi() {
      return this.unit.lqi !== '' && this.unit.lqi !== null;
    },
    selectedFormat() {
      return 1;
    },
  },
  methods: {
    getTimmingOption(value) {
      return this.dynamicTiming.find(item => item.value === value);
    },
    getSensingOption(value) {
      return dynamicSensing.find(item => item.value === value);
    },
    updateTentacles(data) {
      this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
        if (response.status === 200) {
          this.flash('Tentacles updated', 'success');
          this.$store.dispatch('tentacle/setUnitByID', this.unit.id).then((response) => {
            if (response.status === 200) {
            }
          });
        }
      });
    },
    setDynamicTiming(option) {
      this.updateTentacles([{ id: this.unit.id, measurementInterval: option.value }]);
    },
    setDynamicSensing(option) {
      this.updateTentacles([{ id: this.unit.id, dynamicSensing: option.value }]);
    },
    getUtcDateTime(date){
      return new Date(date.getUTCFullYear(),date.getUTCMonth(),date.getUTCDate(),date.getUTCHours(),date.getUTCMinutes(),date.getUTCSeconds());
    },
    showInEnv(type) {
      if (Array.isArray(type)) {
        return type.includes(process.env.VUE_APP_ENVIRONMENT);
      }
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
  },
};
</script>

<style lang="scss" scoped>

  .lqi-info {
    margin-left: auto;
    display: flex;
    padding: 10px 15px;
    line-height: 20px;
    font-size: 15px;
    font-weight: 500;

    &.Excellent {
      color: #b2de4d;
    }
    &.Good {
      color: #cbcd4b;
    }
    &.Average {
      color: #dea44d;
    }
    &.Limit {
      color: #ff5355;
    }
  }

.detail-settings {
  padding-left: 8rem;
  @media only screen and (max-width: 990px) {
    padding-left: 0;
    width: 90%;
    margin-right: auto;
    margin-left: 5%;
  }
  @media only screen and (min-width: 991px) and (max-width: 1199px) {
    padding-left: 0;
    width: 90%;
    margin-right: auto;
    margin-left: 5%;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1400px) {
    margin-left: -4%;
    width: 100%;
  }

  &__panel {
    border-radius: 2rem;
    background-color: $white;
    box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
      position: relative;
      .loading-wrapper {
          position: absolute;
          top: 5rem;
          width: 100%;
          height: calc(100% - 10rem);
          background-color: rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
      }
    &__header {
      padding: 0 3rem;
      height: 6rem;
      border-bottom: 0.1rem solid $border-color;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 1.4rem;
      color: $grey;
    }

    &__content {
        @media only screen and (max-width: 1400px) {
            min-height: 26rem;
        }
    }
  }
}
</style>
